<template>
    <div class="machine-map" ref="map"></div>
</template>

<script>
  import $ from 'jquery'
  import ymap from '../../ymap'
  import {debounce} from 'lodash'

  export default {
    props: {
      value: {
        required: true,
      },
    },
    data () {
      return {
        placemark: null,
        map: null,
      }
    },
    watch: {
      location: {
        handler: debounce(function () {
          this.movePlacemark()
        }, 500),
        deep: true,
      },
    },
    computed: {
      location () {
        return this.value ? this.value : {}
      },
      longitude () {
        return this.location.lon || 37.388753
      },
      latitude () {
        return this.location.lat || 55.711863
      },
    },
    methods: {
      movePlacemark () {
        ymap().then(ymaps => {
          this.map.geoObjects.remove(this.placemark)
          this.addPlacemark(ymaps)
        })
      },
      addPlacemark (ymaps) {
        this.$nextTick(() => {
          this.placemark = new ymaps.Placemark([this.latitude, this.longitude], {
          }, {
            preset: `islands#$redIcon`,
          })
          this.map.geoObjects.add(this.placemark)
          this.map.setCenter([this.latitude, this.longitude])
        })
      },
    },
    mounted () {
      ymap().then(ymaps => {
        this.map = new ymaps.Map(this.$refs.map, {
          zoom: 11,
          center: [this.latitude, this.longitude],
          controls: ['fullscreenControl', 'geolocationControl', 'zoomControl'],
        }, {searchControlProvider: 'yandex#search'})
        this.map.events.add('click', (e) => {
          const coords = e.get('coords')
          this.$emit('input', {
            lat: coords[0],
            lon: coords[1],
          })
        })
        this.addPlacemark(ymaps)
      })
    },
    beforeDestroy () {
      if (this.map) this.map.destroy()
    },
  }
</script>

<style lang="scss">
  .machine-map {
    overflow: hidden;
    width: 100%;
    height: 15em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/map.vue